module.exports = __webpack_public_path__ + "static/media/tass-min.47e627f2.png";